import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent } from './ui/card';
import { Feather } from 'lucide-react';
import api from '../services/api';

const LyricCard = ({ snippet, index }) => (
  <Card
    className="bg-gradient-to-br from-[#1e2749]/80 to-[#2d3561]/60 border-[#d4af37]/30 hover:border-[#d4af37] transition-all duration-500 overflow-hidden group"
    style={{
      animationDelay: `${index * 150}ms`,
      animation: 'fadeInLeft 0.8s ease-out forwards',
      opacity: 0
    }}
  >
    <CardContent className="p-8 md:p-12">
      <div className="flex items-start space-x-4 mb-6">
        <div className="flex-shrink-0">
          <Feather className="w-8 h-8 text-[#d4af37]" />
        </div>
        <div className="flex-1">
          <h3
            className="text-2xl md:text-3xl font-bold text-white mb-2"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {snippet.trackTitle}
          </h3>
          <span className="text-sm text-[#d4af37] uppercase tracking-wider">
            {snippet.language}
          </span>
        </div>
      </div>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#d4af37] to-transparent" />
        <div className="pl-6">
          <p
            className="text-gray-300 text-lg md:text-xl leading-relaxed whitespace-pre-line italic"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {snippet.lyrics}
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const LyricsSection = () => {
  const [lyrics, setLyrics] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLyrics = useCallback(async () => {
    try {
      const response = await api.getLyrics();
      setLyrics(response.data);
    } catch (err) {
      console.error('Error fetching lyrics:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLyrics();
  }, [fetchLyrics]);

  if (loading) {
    return (
      <section className="py-20 bg-[#0a1128]">
        <div className="container mx-auto px-6 text-center">
          <div className="text-white text-xl">Loading lyrics...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="lyrics" className="py-20 bg-[#0a1128]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Lyrics
          </h2>
          <div className="w-24 h-1 bg-[#d4af37] mx-auto mb-4" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Words that paint emotions, verses that touch the heart
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-8">
          {lyrics.map((snippet, index) => (
            <LyricCard key={snippet._id} snippet={snippet} index={index} />
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500 italic">
            More lyrics will be added as the journey continues...
          </p>
        </div>
      </div>
    </section>
  );
};

export default LyricsSection;
